const PRIORITY_TASKS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  isCreateLoading: false,
  createError: undefined,
  data: undefined,
}

export default PRIORITY_TASKS_INITIAL_STATE
